<template>
  <b-container>
    <b-row>
      <b-col :cols="getSize()">
        <b-alert show v-if="displayMaintenanceWindow" variant="warning">
          <h4 class="alert-heading"><strong>Geplantes Wartungsfenster</strong></h4>
          <p class="mb-0">
            <strong>Am 30.01.2024 von 20:00 Uhr bis voraussichtlich 21:00 Uhr wird das eFörderportal nicht zur Verfügung stehen. Danke für Ihr Verständnis.</strong>
          </p>
        </b-alert>
        <h1>Fördergeldrechner</h1>
        <community-select />
        <calculator-type-select v-if="communityId" />
        <calculator-application-form v-if="communityId && calculatorType"/>
        <estimate-result v-if="Object.keys(estimate).length" />
      </b-col>
      <b-col>
        <community-info />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import { mapState } from 'vuex'
  import CommunitySelect from '@/components/calculator/CommunitySelect.vue'
  import CalculatorTypeSelect from '@/components/calculator/CalculatorTypeSelect.vue'
  import CalculatorApplicationForm from '@/components/calculator/CalculatorApplicationForm.vue'
  import EstimateResult from '@/components/calculator/EstimateResult.vue'
  import CommunityInfo from '@/components/calculator/CommunityInfo.vue'

  export default {
    data: () => ({
      isPublic: false
    }),
    created () {
      this.isPublic = this.$route.name === 'foerdergeldrechner'
    },
    methods: {
      getSize () {
        if (this.isPublic) {
          return 'lg-12'
        }
        return 'lg-7'
      }
    },
    computed: {
      displayMaintenanceWindow () {
        const currentDateTime = new Date()
        const endMaintenance = new Date(2024, 0, 30, 21, 0, 0)
        let showWindow = false
        if (currentDateTime < endMaintenance) {
          showWindow = true
        }
        return showWindow
      },
      ...mapState({
        communityId: state => state.calculator.communityId,
        calculatorType: state => state.calculator.calculatorType,
        estimate: state => state.calculator.estimate
      })
    },
    components: {
      CommunitySelect,
      CalculatorTypeSelect,
      CalculatorApplicationForm,
      EstimateResult,
      CommunityInfo
    }
  }
</script>
